import BulbIcon from '@app/assets/icons/menu/bulb.svg?react';
import {Button, ConfirmDialog, IntegrationMenu} from '@app/components';
import {ContactUsEmail, IntegrationLabels, IntegrationType} from '@app/utils/consts';


import AddIcon from '@app/assets/icons/add.svg?react';
import {useIntegrationsCrm} from "@app/pages/IntegrationsCRM/IntegrationsCrm.hooks.ts";

export const IntegrationsCRM = () => {
  const {
    // saveIntegrationForm,
    // saveIntegrationSubmit,
    // handleIntegrationModal,
    // integrationFormModal,
    listOfIntegrations,
    // handleUpdateIntegrationModal,
    // updateIntegrationFormModal,
    // updateIntegrationForm,
    // updateIntegrationSubmit,
    deleteIntegrationAction,
    confirmDeleteIntegration,
    confirmDeleteType,
    setConfirmDeleteType,
    handleNangoIntegration,
    nowConnectingIntegration,
  } = useIntegrationsCrm();

  const integrationsOrder: IntegrationType[] = [
    IntegrationType.JOBBER,
    IntegrationType.SQUAREUP,
  ];

  const INTEGRATION_TEXTS: Partial<Record<IntegrationType, string>> = {
    [IntegrationType.JOBBER]: 'Integrate with Jobber to sync your clients, jobs, and invoices in real time. This will allow you to trigger automations within our platform.',
    [IntegrationType.SQUAREUP]: 'Integrate with SquareUp to sync your customers. This will allow you to trigger automations within our platform.',
  };

  const getIntegrationDescription = (integration: IntegrationType): string => {
    return INTEGRATION_TEXTS[integration] ?? 'Integrate with your CRM system to sync customer data and track interactions. This will allow you to trigger automations within our platform.';
  };

  const sortedIntegrations = listOfIntegrations.sort((a, b) => {
    const indexA = integrationsOrder.indexOf(a.type);
    const indexB = integrationsOrder.indexOf(b.type);

    const priorityA = indexA === -1 ? Infinity : indexA;
    const priorityB = indexB === -1 ? Infinity : indexB;

    return priorityA - priorityB;
  });

  return (
    <div>
      <div className="bg-white border-b border-b-base-ghostWhite ">
        <div className="container mx-auto p-4 flex flex-col md:flex-row justify-between gap-4">
          <div>
            <h2 className="font-bold text-[28px]">CRM connection</h2>
            <p className="text-base-coolGray">
              Choose a CRM to easily import your customer list. Full integration
              with these CRMs ensures that
              <br /> your customer database is centralized here.
            </p>
          </div>
          <div>
            <div className="bg-brand-lightBlue3 p-4  rounded-lg text-sm font-medium text-brand-darkBlue1 flex gap-2">
              <div>
                <BulbIcon
                  className="[&_path]:stroke-brand-baseBlue"
                  width={20}
                  height={20}
                />
              </div>
              <div>
                <p>
                  Want to integrate a CRM that is not listed
                  <br /> here? Contact us!
                  <br /> And we will consider the possibility of adding it
                  <br /> to the list of integrations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto p-4">
        <div className={sortedIntegrations.length === 1 ? 'flex items-center justify-center' : 'grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-4'}>
          {sortedIntegrations.map((integration) => {
            return (
                <div key={integration.type} className="bg-white p-4 rounded-lg flex flex-col h-full" style={sortedIntegrations.length === 1 ? { maxWidth: '400px' } : {}}>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                      <div className="w-10 h-10 rounded-lg bg-base-antiFlash flex items-center justify-center">{integration.icon && <integration.icon />}</div>
                      <div className="flex items-center gap-2">
                        <p className="text-base-davyGray font-medium">
                          {integration.title}
                        </p>
                      </div>
                    </div>
                    {integration.hasConnection && (
                        <IntegrationMenu
                            id={integration.type}
                            updateAction={undefined}
                            deleteAction={() => deleteIntegrationAction(integration.type)}
                            disabled={!!nowConnectingIntegration}
                        />
                    )}
                  </div>
                  {integration?.details?.accountText && integration.hasConnection && (
                      <p className="text-base-davyGray text-sm flex-grow mb-4">
                        <span className="font-medium text-brand-baseBlue">
                          {integration?.details?.accountText}
                        </span>{' '}
                        is linked to your Echo business account.
                      </p>
                  )}
                  <p className="text-base-davyGray text-sm flex-grow mb-4">
                    {getIntegrationDescription(integration.type)}
                  </p>
                  <div className="flex justify-end mt-auto">
                    {integration.isNangoConnection && !integration.hasConnection && (
                      <Button
                          disabled={!integration.available || !!nowConnectingIntegration}
                          leftNode={integration.available ? <AddIcon /> : undefined}
                          onClick={() => handleNangoIntegration(integration)}
                          className={`min-w-fit ${!integration.available ? '!bg-[#E7EAF4] !text-black' : ''}`}
                      >
                        Connect
                      </Button>
                    )}


                    {/*<Button*/}
                    {/*    disabled={!integration.available || !!nowConnectingIntegration}*/}
                    {/*    leftNode={integration.available ? <AddIcon /> : undefined}*/}
                    {/*    onClick={() => {*/}
                    {/*      if (integration.hasConnection) {*/}
                    {/*        handleUpdateIntegrationModal(integration);*/}
                    {/*      } else if (integration.isNangoConnection) {*/}
                    {/*        handleNangoIntegration(integration);*/}
                    {/*      } else {*/}
                    {/*        handleIntegrationModal(integration.type);*/}
                    {/*      }*/}
                    {/*    }}*/}
                    {/*    className={`min-w-fit ${!integration.available ? '!bg-[#E7EAF4] !text-black' : ''}`}*/}
                    {/*>*/}
                    {/*  {integration.hasConnection*/}
                    {/*      ? 'Edit Connection'*/}
                    {/*      : integration.available*/}
                    {/*          ? 'Connect'*/}
                    {/*          : 'Coming soon'}*/}
                    {/*</Button>*/}
                  </div>
                </div>
            );
          })}
        </div>
        {/*<div className="my-16">*/}
        {/*  <pre style={{ border: 'solid 1px green', textAlign: 'left' }}>{ JSON.stringify({listOfIntegrations}, null, 4) }</pre>*/}
        {/*  <pre style={{ border: 'solid 1px red', textAlign: 'left' }}>{ JSON.stringify({integrationsResponse}, null, 4) }</pre>*/}
        {/*</div>*/}
        <div className="my-16">
          <div className="max-w-xl mx-auto border-dashed border-2 border-base-lavender p-6 space-y-6 text-center rounded-xl">
            <h5 className="font-bold">Don't see your CRM?</h5>
            <p className="text-base-davyGray">
              Click here and request that it be added
            </p>
            <a href={`mailto:${ContactUsEmail}`} className="inline-block">
              <Button className="mx-auto">Contact us</Button>
            </a>
          </div>
        </div>
      </div>

      <ConfirmDialog
          open={Boolean(confirmDeleteType)}
          onClose={() => setConfirmDeleteType(undefined)}
          onConfirm={confirmDeleteIntegration}
          title={`Disconnect ${confirmDeleteType ? IntegrationLabels[confirmDeleteType] : ''}  Integration?`}
          message={`Are you sure you want to disconnect this integration from the system? You can reconnect the integration later.`}
          confirmText="Disconnect"
          variant="danger"
      />
    </div>
  );
};
